import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header.jsx";
import { isAuthenticated, login, signup } from "../services/auth.js";

const FEATURES = [
  {
    title: "1:1 coaching",
    description: "Strategic advice from AI-powered advisors",
  },
  {
    title: "Roundtables",
    description: "Multi-perspective debates on your toughest decisions",
  },
  {
    title: "Research",
    description: "AI-driven account intelligence in minutes",
  },
];

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated()) navigate("/", { replace: true });
  }, [navigate]);

  return (
    <>
      <Header />
      <main className="landing">
        <section className="landing-hero">
          <h1>
            AI <span className="accent">Coach</span>
          </h1>
          <p>Get strategic advice from AI-powered advisors</p>
          <div className="landing-cta">
            <button type="button" className="btn btn-primary" onClick={login}>
              Sign in to start
            </button>
            <button type="button" className="btn btn-ghost" onClick={signup}>
              Create an account
            </button>
          </div>
        </section>

        <section className="landing-features">
          {FEATURES.map((f) => (
            <article key={f.title} className="feature-card">
              <h2>{f.title}</h2>
              <p>{f.description}</p>
            </article>
          ))}
        </section>
      </main>
    </>
  );
}
